export default __webpack_public_path__ + "static/media/011-coconut.8e6f195f.svg";